import React, { useEffect, useState } from "react"
import { LocalPersistence } from '../../../../../factories';
import { Form, Row, Col, Select, message } from 'antd';
import Input from '../../../../ui/Input'
import ActionButtonsBar from '../../../../ui/ActionButtonsBar'
import DropDown from '../../../../ui/DropDown'
import { saveOrUpdateMeetingRoomsPayment } from '../../../../../services/meetingrooms'
import styles from '../../index.module.css'
import Loading from "../../../../Loading";
import {PAYMENT_FIELDS,PaymentFieldsType,PAYMENT_OPTIONS, PAYMENT_OPTIONS_NA} from '../helper/index'
import {SelectValue} from 'antd/lib/select'

const MeetingPaymentEdit = (props: any) => {
    const [form] = Form.useForm()
    const [editLoading, setEditLoading] = useState(false)
    const [disabledStatus, setDisabledStatus] = useState<boolean>(false)
    const [maxAmountGroup, setMaxAmountGroup] = useState<boolean>(true)
    const [directBill, setDirectBill] = useState<boolean>(true)
    const [minimumSpentdirectBill, setMinimumSpentdirectBill] = useState<boolean>(true)
    const [maximumSpentdirectBill, setMaximumSpentdirectBill] = useState<boolean>(true)

    const SaveClick = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()

        form.validateFields().then(async (value) => {
            setEditLoading(true)
            let bodyQuery = {
                "supplier": session.supplier,
                "propertyId": session.propertyId,
                "property": {
                    "meetingrooms": {
                        "meetingroomsid": props.paymentData.meetingroomsid,
                        // "meetingroomslangid":props.paymentData.meetingroomslangid,
                        "payment": {
                            "amex": value.amex || '',
                            "visa": value.visa || '',
                            "mastercard": value.mastercard || '',
                            "jcb": value.jcb || '',
                            "dinersclub": value.dinersclub || '',
                            "discovery": value.discovery || '',
                            "corporatemeetingcard": value.corporatemeetingcard || '',
                            "advanceddepositrequired": value.advanceddepositrequired || '',
                            "fundsheld": value.fundsheld || '',
                            "ismaxamount": value.ismaxamount || '',
                            "maxamount": value.maxamount || '',
                            "isDirectBill": value?.isDirectBill,
                            "directBillPaymentTerms": value?.directBillPaymentTerms,
                            "isMinimumSpendToDirectBill": value?.isMinimumSpendToDirectBill,
                            "minimumSpendToDirectBillAmount": value?.minimumSpendToDirectBillAmount,
                            "isMaximumSpendToDirectBill": value?.isMaximumSpendToDirectBill,
                            "maximumSpendToDirectBillAmount": value?.maximumSpendToDirectBillAmount
                        }
                    }
                }
            }
            saveOrUpdateMeetingRoomsPayment(bodyQuery).then(res => {
                if (res.result.success) {
                    props.setPaymentData({
                        "meetingroomsid": props.paymentData.meetingroomsid,
                        "meetingroomslangid": props.paymentData.meetingroomslangid,
                        "amex": value.amex || '',
                        "visa": value.visa || '',
                        "mastercard": value.mastercard || '',
                        "jcb": value.jcb || '',
                        "dinersclub": value.dinersclub || '',
                        "discovery": value.discovery || '',
                        "corporatemeetingcard": value.corporatemeetingcard || '',
                        "advanceddepositrequired": value.advanceddepositrequired || '',
                        "fundsheld": value.fundsheld || '',
                        "ismaxamount": value.ismaxamount || '',
                        "maxamount": value.maxamount || '',
                        "isDirectBill": value?.isDirectBill,
                        "directBillPaymentTerms": value?.directBillPaymentTerms,
                        "isMinimumSpendToDirectBill": value?.isMinimumSpendToDirectBill,
                        "minimumSpendToDirectBillAmount": value?.minimumSpendToDirectBillAmount,
                        "isMaximumSpendToDirectBill": value?.isMaximumSpendToDirectBill,
                        "maximumSpendToDirectBillAmount": value?.maximumSpendToDirectBillAmount
                    })
                    props.setEditFlag(false)
                    window.cancelEdition()
                    props.setOneNavDisabled(false)
                } else {
                    message.error({
                        content: res?.error[0]?.message || 'operation failed'
                    });
                }
                setEditLoading(false)
            }, err => {
                message.error({
                    content: err?.message || err?.error[0]?.message
                });
                setEditLoading(false)
            })
        }).catch(() => {
            setEditLoading(false)
            message.error({
                content: 'Check all the fields please.',
            });
        })
    }

    useEffect(() => {
        getAllData()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

    const validateFieldsError = (changedValues: any, allValues: any) => {
        form.validateFields().then(() => {
            setDisabledStatus(false)

        }).catch(() => {
            let savelock = false
            let s = form?.getFieldsError()
            for (let i = 0; i < s.length; i++) {
                if (s[i].errors.length) {
                    savelock = true;
                    break
                }
            }
            setDisabledStatus(savelock)
        })
    }

    const getAllData = async () => {
        form.setFieldsValue({
            "amex": props.paymentData.amex,
            "visa": props.paymentData.visa,
            "mastercard": props.paymentData.mastercard,
            "jcb": props.paymentData.jcb,
            "dinersclub": props.paymentData.dinersclub,
            "discovery": props.paymentData.discovery,
            "corporatemeetingcard": props.paymentData.corporatemeetingcard,
            "fundsheld": props.paymentData.fundsheld,
            "advanceddepositrequired": props.paymentData.advanceddepositrequired,
            "ismaxamount": props.paymentData.ismaxamount,
            "maxamount": props.paymentData.maxamount,
            "isDirectBill": props.paymentData?.isDirectBill,
            "directBillPaymentTerms": props.paymentData?.directBillPaymentTerms,
            "isMinimumSpendToDirectBill": props.paymentData?.isMinimumSpendToDirectBill,
            "minimumSpendToDirectBillAmount": props.paymentData?.minimumSpendToDirectBillAmount,
            "isMaximumSpendToDirectBill": props.paymentData?.isMaximumSpendToDirectBill,
            "maximumSpendToDirectBillAmount": props.paymentData?.maximumSpendToDirectBillAmount
        })
    }

    const handleSelect = (opt:SelectValue,name:string) =>{
        if(name === 'ismaxamount'){
            if(opt === 'Yes'){
                setMaxAmountGroup(true)
            }else{
                form.setFieldsValue({"maxamount": ''})
                setMaxAmountGroup(false) 
            }
        }
        if(name === 'isDirectBill'){
            if(opt === 'Yes'){
                setDirectBill(true)
            }else{
                form.setFieldsValue({"directBillPaymentTerms": ''})
                setDirectBill(false) 
            }
        }
        if(name === 'isMinimumSpendToDirectBill'){
            if(opt === 'Yes'){
                setMinimumSpentdirectBill(true)
            }else{
                form.setFieldsValue({"minimumSpendToDirectBillAmount": ''})
                setMinimumSpentdirectBill(false) 
            }
        }
        if(name === 'isMaximumSpendToDirectBill'){
            if(opt === 'Yes'){
                setMaximumSpentdirectBill(true)
            }else{
                form.setFieldsValue({"maximumSpendToDirectBillAmount": ''})
                setMaximumSpentdirectBill(false) 
            }
        }
    }

    useEffect(() => {
        if(props.paymentData.isMinimumSpendToDirectBill === 'Yes'){
            setMinimumSpentdirectBill(true)
        } else {
            setMinimumSpentdirectBill(false) 
        }
        if(props.paymentData.isMaximumSpendToDirectBill === 'Yes'){
            setMaximumSpentdirectBill(true)
        }else{
            setMaximumSpentdirectBill(false) 
        }
    }, [])

    if (editLoading) return <Loading type='large' />
    return (
      <div className={styles.outCon}>
        <div className={styles.inCon}>
          <div style={{ fontWeight: 600, fontSize: 14, color: '#333', paddingLeft: '4px' }}>Meeting Payment</div>
        </div>
        <Form
          layout='vertical'
          form={form}
          name='basic'
          initialValues={{ remember: true }}
          onValuesChange={validateFieldsError}
          style={{ paddingBottom: "50px" }}>
              <Row gutter={24}>
                {
                    PAYMENT_FIELDS.map((item:PaymentFieldsType, i:number) => {
                            return item.label ? !item.noSelectable ?
                            <Col span={item.span} key={i} className="col-margin">
                                    <DropDown 
                                        onChange={handleSelect} 
                                        label={item.label} 
                                        name={item.name} 
                                        options={item.name === 'isMinimumSpendToDirectBill' || item.name === 'isMaximumSpendToDirectBill' ? PAYMENT_OPTIONS_NA : PAYMENT_OPTIONS} 
                                    />
                            </Col> : 
                            <Col span={6}>
                                { item.name === 'maxamount' && <Form.Item
                                    label={item.label}
                                    name={item.name}>
                                    <Input disabled={!maxAmountGroup} maxLength={item.maxlength} />
                                  </Form.Item>
                                }
                                { item.name === 'directBillPaymentTerms' && <Form.Item
                                    label={item.label}
                                    name={item.name}
                                    rules={[
                                        () => ({
                                            validator(_, value) {
                                              /* if (!value) {
                                                return Promise.reject();
                                              }
                                              if (isNaN(value)) {
                                                return Promise.reject("This field should be a number");
                                              } */
                                              if (!value) {
                                                return Promise.resolve();
                                              }
                                              if (value.length > 50) {
                                                return Promise.reject("You have reached the max character length of 50");
                                              }
                                              return Promise.resolve();
                                            },
                                          }),
                                      ]}
                                    >
                                    <Input disabled={!directBill} maxLength={item.maxlength} />
                                  </Form.Item>
                                }
                                { item.name === 'minimumSpendToDirectBillAmount' && <Form.Item
                                    label={item.label}
                                    name={item.name}
                                    rules={[
                                        {
                                          pattern: /^[0-9]*(\.[0-9]{0,4})?$/,
                                          message: 'This field should be a number',
                                        },
                                        () => ({
                                            validator(_, value) {
                                              /* if (!value) {
                                                return Promise.reject();
                                              }
                                              if (isNaN(value)) {
                                                return Promise.reject("This field should be a number");
                                              } */
                                              if (!value) {
                                                return Promise.resolve();
                                              }
                                              if (value.length > 8) {
                                                return Promise.reject("You have reached the max character length of 8");
                                              }
                                              return Promise.resolve();
                                            },
                                          }),
                                      ]}>
                                    <Input disabled={!minimumSpentdirectBill} maxLength={8} />
                                  </Form.Item>
                                }
                                { item.name === 'maximumSpendToDirectBillAmount' && <Form.Item
                                    label={item.label}
                                    name={item.name}
                                    rules={[
                                        {
                                          pattern: /^[0-9]*(\.[0-9]{0,4})?$/,
                                          message: 'This field should be a number',
                                        },
                                        () => ({
                                            validator(_, value) {
                                              /*
                                              if (isNaN(value)) {
                                                return Promise.reject("This field should be a number");
                                              } */
                                              if (!value) {
                                                return Promise.resolve();
                                              }
                                              if (value.length > 8) {
                                                return Promise.reject("You have reached the max character length of 8");
                                              }
                                              return Promise.resolve();
                                            },
                                          }),
                                      ]}>
                                    <Input disabled={!maximumSpentdirectBill} maxLength={8} />
                                  </Form.Item>
                                }
                            </Col> :
                            <Col span={item.span} key={i}></Col>
                })
                }
              </Row>
        </Form>
        <ActionButtonsBar
          onCancel={() => {
            props.setEditFlag(false)
            window.cancelEdition()
            props.setOneNavDisabled(false)
          }}
          onSave={SaveClick}
          disabledSave={disabledStatus}
        />
      </div>
    )
}

export default MeetingPaymentEdit
